import React, { useState, useEffect } from 'react';

const PHASES = [
  {
    label: 'Nos primeiros dias',
    items: [
      'Mais saciedade entre as refeições.',
      'Menos vontade de comer doces.',
      'Muitas pessoas relatam maior eliminação de líquidos, indo mais vezes ao banheiro, principalmente quando havia retenção.'
    ]
  },
  {
    label: 'Ao longo das primeiras semanas',
    items: [
      'As roupas ficam mais folgadas.',
      'As primeiras mudanças no espelho passam a ser percebidas.',
      'Muitos clientes relatam redução gradual do peso, o que aumenta a motivação para continuar.'
    ]
  },
  {
    label: 'Com o uso contínuo',
    items: [
      'Mais controle do apetite.',
      'Menos episódios de exagero na alimentação.',
      'A diferença na balança começa a aparecer de forma cada vez mais perceptível.',
      'Numeração menor de roupas.',
      'A satisfação de perceber que o emagrecimento finalmente está acontecendo.'
    ]
  }
];

const AUTOPLAY_MS = 8000;

const ResultsSection = () => {
  const [active, setActive] = useState(0);

  // Auto-rotação entre os tópicos (reinicia a cada mudança/clique)
  useEffect(() => {
    const timer = setTimeout(() => {
      setActive((prev) => (prev + 1) % PHASES.length);
    }, AUTOPLAY_MS);
    return () => clearTimeout(timer);
  }, [active]);

  const phase = PHASES[active];

  return (
    <section id="results" className="mgs-results">
      <div className="mgs-results__inner">
        <h2 className="mgs-results__title">
          Resultados <span className="mgs-results__title-gold">com Magrisim</span>
        </h2>
        <p className="mgs-results__subtitle">
          O que a maioria dos nossos clientes relata:
        </p>

        {/* Abas / etapas */}
        <div className="mgs-results__tabs" role="tablist">
          {PHASES.map((ph, i) => (
            <button
              key={i}
              type="button"
              role="tab"
              className={`mgs-results__tab${active === i ? ' is-active' : ''}`}
              onClick={() => setActive(i)}
              aria-selected={active === i}
            >
              <span className="mgs-results__tab-num">{i + 1}</span>
              <span className="mgs-results__tab-label">{ph.label}</span>
            </button>
          ))}
        </div>

        {/* Painel que troca com efeito de transição */}
        <div className="mgs-results__panel" key={active}>
          <h3 className="mgs-results__panel-title">{phase.label}</h3>
          <ul className="mgs-results__list">
            {phase.items.map((item, i) => (
              <li key={i} className="mgs-results__item">
                <i className="fas fa-check"></i>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Barra de progresso do autoplay (reinicia a cada etapa) */}
        <div className="mgs-results__progress" key={`progress-${active}`}>
          <span
            className="mgs-results__progress-fill"
            style={{ animationDuration: `${AUTOPLAY_MS}ms` }}
          />
        </div>

        {/* Indicadores */}
        <div className="mgs-results__dots">
          {PHASES.map((_, i) => (
            <button
              key={i}
              type="button"
              className={`mgs-results__dot${active === i ? ' is-active' : ''}`}
              onClick={() => setActive(i)}
              aria-label={`Ver etapa ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ResultsSection;
